module.exports = __webpack_public_path__ + "img/main.65fb0cb7.png";